
import React, { useState, useEffect } from "react";
import { v4 } from "uuid";
import MarkDownEditor from "../MarkDownEditor";
import { mainCollection, storage } from "../../config/firebase";
import { DocumentData, setDoc, QueryDocumentSnapshot, addDoc } from 'firebase/firestore';

import { ref, uploadBytes, getDownloadURL, StorageReference, UploadResult, deleteObject } from "firebase/storage";

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Grid, FormControl, InputLabel, OutlinedInput, Chip, Select, MenuItem, Autocomplete, TextField, CircularProgress, ImageListItem, ImageList, ImageListItemBar, IconButton } from "@mui/material";

import { Add, Delete } from '@mui/icons-material';
import { AppData } from "../../Data/Models/AppData";
import { maxScreenshots } from "../../config/const";

interface ToggleProps {
  toggle: [boolean, React.Dispatch<React.SetStateAction<boolean>>],
  updateData: QueryDocumentSnapshot<DocumentData> | null
}

function getLoadingView() {
  return (<CircularProgress color="secondary" />)
}

function generateImageViewIconUrl(url: string | null | undefined) {
  if (url)
    return (<img width={64} height={64} src={url} />)
  else
    return (<Add />)
}

function generateImageViewFeatureUrl(url: string | null | undefined) {
  if (url)
    return (<img height={256} src={url} />)
  else
    return (<>Add feature image</>)
}

export default function FormAddApp(pops: ToggleProps) {

  const [open, setOpen] = pops.toggle
  const [openMd, setOpenMd] = useState(false)
  const [nameField, setName] = useState("")
  const [descField, setDesc] = useState("")
  const [markDownData, setMarkDownData] = React.useState("");
  const [gitUrlField, setGitUrl] = useState("")
  const [playUrlField, setPlayUrl] = useState("")
  const [selected, setSelected] = useState<string | number>(0)
  const [receivers, setReceivers] = React.useState<string[]>([]);

  const [IconAddButtonElement, setIconAddButton] = useState(<>Icon</>)
  const [featureImageAddButtonElement, setFeatureImageAddButton] = useState(<>Featured Image</>)
  const [addScreenShotsButtonElement, setScreenShotsAddButton] = useState(<>Add Screenshots</>)

  const [screenshotsDownloadUrlsField, setScreenshotsDownloadUrlsField] = useState<string[]>([])
  const [iconDownloadUrlField, setIconDownloadUrlField] = useState("")
  const [featureImageDownloadUrlField, setFeatureImageDownloadUrlField] = useState("")
  const [urlsToBeDeleted, setUrlsToBeDeleted] = useState<StorageReference[]>([])

  let populateData: QueryDocumentSnapshot<DocumentData> | null = pops.updateData

  useEffect(() => {

    if (populateData && open) {
      let data = populateData.data() as AppData

      console.log(data)
      setName(data.name)
      setDesc(data.description)
      setSelected(data.type)
      setGitUrl(data.gitUrl)
      setMarkDownData(data.markDown)
      setPlayUrl(data.playStoreUrl)
      setReceivers(data.tags)
      setIconDownloadUrlField(data.iconUrl)
      setFeatureImageDownloadUrlField(data.featureImageUrl)
      setScreenshotsDownloadUrlsField(data.screenshotUrls)

      setIconAddButton(generateImageViewIconUrl(data.iconUrl))
      setFeatureImageAddButton(generateImageViewFeatureUrl(data.featureImageUrl))

    }
  }, [open])

  const clearAll = () => {
    setName("")
    setDesc("")
    setSelected("")
    setGitUrl("")
    setPlayUrl("")
    setMarkDownData("")
    setReceivers([])
    setIconDownloadUrlField("")
    setFeatureImageDownloadUrlField("")
    setScreenshotsDownloadUrlsField([])
    setIconAddButton(<>Icon</>)
    setFeatureImageAddButton(<>Featured Image</>)
    setDefaultAddScreenshotButton()
    populateData = null
  }

  const setDefaultAddScreenshotButton = () => {
    setScreenShotsAddButton(<>Add Screenshots</>)
  }

  const handleClose = () => {
    clearAll();
    setOpen(false);
  };

  const handleDelete = (index: number) => {
    const imgs = [...screenshotsDownloadUrlsField]
    const img = imgs[index]
    let refImg = ref(storage, img)
    setUrlsToBeDeleted([...urlsToBeDeleted, refImg])
    imgs.splice(index, 1)
    setScreenshotsDownloadUrlsField(imgs)
  }

  const handleIconSelected = (e: React.ChangeEvent<HTMLInputElement>) => {
    let file = e.target.files?.item(0)

    if (file) {

      setIconAddButton(getLoadingView)

      var iconFilename = `icons/${v4() + file.name}`
      var iconRef = ref(storage, iconFilename)

      uploadBytes(iconRef, file).then(() => {

        getDownloadURL(iconRef)
          .then((url) => {
            setIconDownloadUrlField(url);
            setIconAddButton(generateImageViewIconUrl(url))
            console.log("fetched icon url" + url)
          })
          .catch((error) => {
            console.log("Error getting Icon download URL: ", error);
            setIconAddButton(generateImageViewIconUrl(null))
          })

      }).catch((error) => {
        setIconAddButton(generateImageViewIconUrl(null))
        console.log("Image Icon Upload error: " + error)
      })

    }
  }

  const handleFeatureSelected = (e: React.ChangeEvent<HTMLInputElement>) => {
    let file = e.target.files?.item(0)

    if (file) {

      setFeatureImageAddButton(getLoadingView)

      var featureFilename = `features/${v4() + file.name}`
      var featureRef = ref(storage, featureFilename)

      uploadBytes(featureRef, file).then(() => {

        getDownloadURL(featureRef)
          .then((url) => {
            setFeatureImageDownloadUrlField(url);
            setFeatureImageAddButton(generateImageViewFeatureUrl(url))
            console.log("fetched feature url" + url)
          })
          .catch((error) => {
            setFeatureImageAddButton(generateImageViewFeatureUrl(null))
            console.log("Error getting feature download URL: ", error);
          })

      }).catch((error) => {
        setFeatureImageAddButton(generateImageViewFeatureUrl(null))
        console.log("Image feature Upload error: " + error)
      })

    }
  }

  const handleScreenshotsSelected = (e: React.ChangeEvent<HTMLInputElement>) => {
    let files = e.target.files

    if (files) {

      const filesArray = Array.from(files)
      const refs: StorageReference[] = []
      const promises: Promise<UploadResult>[] = []

      filesArray.forEach((e) => {

        setScreenShotsAddButton(getLoadingView)

        const filename: string = `screenshots/${v4() + e.name}`
        const storageRef = ref(storage, filename)
        refs.push(storageRef)
        promises.push(uploadBytes(storageRef, e))
      })

      Promise.all(promises).then((refs) => {

        const promisesDownload: Promise<string>[] = []

        refs.forEach((e) => {
          promisesDownload.push(getDownloadURL(e.ref))
        })

        Promise.all(promisesDownload).then((urls) => {
          setDefaultAddScreenshotButton()
          setScreenshotsDownloadUrlsField([...screenshotsDownloadUrlsField, ...urls])
        }).catch((error) => {
          setDefaultAddScreenshotButton()
          console.log("Error getting screenshot download URL: ", error)
        })
      })
        .catch((error) => {
          setDefaultAddScreenshotButton()
          console.log("Error uploading screenshots: ", error);
        })
    }
  }

  const DeletePending = () => {

    urlsToBeDeleted.forEach((e) => {
      deleteObject(e).then(() => {
        console.log("Deleted from server storage")
      }).catch((error) => {
        console.log("Failed to deleted from server")
        console.log(error)
      })
    })
  }

  const SaveDoc = () => {
    const item = {
      name: nameField,
      description: descField,
      markDown: markDownData,
      type: selected,
      gitUrl: gitUrlField,
      playStoreUrl: playUrlField,
      tags: receivers,
      iconUrl: iconDownloadUrlField,
      featureImageUrl: featureImageDownloadUrlField,
      screenshotUrls: screenshotsDownloadUrlsField
    }

    if (pops.updateData) {
      var ref = pops.updateData.ref
      setDoc(ref, item).then(() => {

        DeletePending()

        alert("Updated")
      }).catch((error) => alert("error occured" + error))
    } else {
      addDoc(mainCollection, item).then(() => {
        alert("Added")
      }).catch((error) => alert("error occured" + error))
    }
  };

  const createNote = (e: React.FormEvent<EventTarget>) => {
    e.preventDefault()
    SaveDoc()
  }

  return (
    <div>

      <Dialog open={open} onClose={handleClose} fullWidth={true}>
        <DialogTitle>Add new app</DialogTitle>
        <DialogContent>
          <Grid container justifyContent={"center"} spacing={1}>

            <Grid item xl={2} md={2} sm={2} xs={2} sx={{ display: 'flex', justifyContent: 'center' }}>
              <Button variant="contained" component="label" >
                {IconAddButtonElement} <input type="file" hidden onChange={(e) => {
                  handleIconSelected(e)
                }} />
              </Button>

            </Grid>

            <Grid item xl={2} md={2} sm={2} xs={2} sx={{ display: 'flex', justifyContent: 'center' }}>
              <Select value={selected} onChange={(e) => {
                setSelected(e.target.value)
              }}>
                <MenuItem value={0}>App</MenuItem>
                <MenuItem value={1}>Library</MenuItem>
              </Select>

            </Grid>

            <Grid item xl={8} md={8} sm={8} xs={8}>

              <FormControl fullWidth >
                <InputLabel htmlFor="component-outlined">App Name</InputLabel>
                <OutlinedInput
                  color="secondary"
                  autoFocus
                  id="name"
                  label="App Name"
                  type="text"
                  value={nameField}
                  fullWidth
                  onChange={(e) => setName(e.target.value)}
                />
              </FormControl>

            </Grid>

            <Grid item xl={12} md={12} sm={12} xs={10}>
              <Button variant="contained" component="label" fullWidth>
                {featureImageAddButtonElement} <input type="file" hidden onChange={(e) => {
                  handleFeatureSelected(e)
                }} />
              </Button>
            </Grid>

            <Grid item xl={12} md={12} sm={12} xs={10}>
              <Button variant="contained" component="label" fullWidth>
                {addScreenShotsButtonElement} <input type="file" hidden multiple onChange={(e) => {
                  handleScreenshotsSelected(e)
                }} />
              </Button>

              <ImageListComponent images={screenshotsDownloadUrlsField} deleteClick={(index) => {
                handleDelete(index)
              }} />
            </Grid>

            <Grid item xl={12} md={12} sm={12} xs={10}>

              <FormControl fullWidth >
                <InputLabel htmlFor="component-outlined">Description</InputLabel>
                <OutlinedInput
                  color="secondary"
                  autoFocus
                  margin="dense"
                  id="description"
                  multiline
                  rows={4}
                  value={descField}
                  label="Description"
                  type="text"
                  fullWidth
                  onChange={(e) => setDesc(e.target.value)}
                />
              </FormControl>

            </Grid>

            <Grid item xl={12} md={12} sm={12} xs={10}>

              <FormControl fullWidth onClick={() => setOpenMd(true)}>
                <InputLabel htmlFor="component-outlined">MarkDown Data</InputLabel>
                <OutlinedInput
                  color="secondary"
                  autoFocus
                  disabled
                  label="MarkDown Data"
                  type="text"
                  fullWidth
                  value={markDownData}
                />
              </FormControl>
            </Grid>

            <Grid item xl={12} md={12} sm={12} xs={12}>

              <FormControl fullWidth >
                <InputLabel htmlFor="component-outlined">GitHub url</InputLabel>
                <OutlinedInput
                  color="secondary"
                  autoFocus
                  id="name"
                  label="App Name"
                  type="text"
                  fullWidth
                  value={gitUrlField}
                  onChange={(e) => setGitUrl(e.target.value)}
                />
              </FormControl>

            </Grid>

            <Grid item xl={12} md={12} sm={12} xs={12}>

              <FormControl fullWidth sx={{ height: "100%" }}>
                <InputLabel htmlFor="component-outlined">PlayStore url</InputLabel>
                <OutlinedInput
                  color="secondary"
                  autoFocus
                  id="name"
                  label="App Name"
                  type="text"
                  fullWidth
                  value={playUrlField}
                  onChange={(e) => setPlayUrl(e.target.value)}
                />
              </FormControl>

            </Grid>

            <Grid item xl={12} md={12} sm={12} xs={12}>
              <Autocomplete
                multiple
                onChange={(e, value) => setReceivers((state) => value)}
                id="tags-filled"
                options={["MVVM", "JetPack", "NDK"]}
                freeSolo
                value={receivers}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Tags"
                    placeholder="Enter Tags and hit enter"
                  />
                )}
              />
            </Grid>

          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">Cancel</Button>
          <Button onClick={createNote} color="secondary">Add</Button>
        </DialogActions>
      </Dialog>

      <MarkDownEditor toggle={[openMd, setOpenMd]} markDownData={[markDownData, setMarkDownData]} ></MarkDownEditor>
    </div>
  );
}


const ImageListComponent = (props: { images: string[], deleteClick: (index: number) => void }) => {

  let colss = props.images.length
  if(colss < maxScreenshots){
    colss = maxScreenshots
  }

  return (<ImageList cols={colss} >
    {props.images.map((item, index) => (
      <ImageListItem key={item}>
        <img
          src={item}
          alt={item}
          loading="lazy"
        />

        <ImageListItemBar
          actionIcon={
            <IconButton
              sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
              aria-label={`info about ${item}`}
              onClick={(e) => {
                props.deleteClick(index)
              }} >
              <Delete />
            </IconButton>
          }
        />
      </ImageListItem>

    ))}
    
  </ImageList>)
}
